import { render, staticRenderFns } from "./_base-course-content-accordion.vue?vue&type=template&id=0fbfc738&scoped=true"
import script from "./_base-course-content-accordion.vue?vue&type=script&lang=js"
export * from "./_base-course-content-accordion.vue?vue&type=script&lang=js"
import style0 from "./_base-course-content-accordion.vue?vue&type=style&index=0&id=0fbfc738&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbfc738",
  null
  
)

export default component.exports